import { ReactComponent as FeatherIcone } from 'core/assets/images/icones/featherIcone.svg'
import Loader from 'core/components/common/Loader'
import { DocumentCard } from 'core/components/documents/DocumentCard'
import { NbDocIcon } from 'lauria/components/common/NbDocIcon'
import { TemperatureSlider } from 'lauria/components/common/TemperatureSlider'
import { ChangePromptStatusModal } from 'lauria/components/prompts/ChangePromptStatusModal'
import { PromptContentCard } from 'lauria/components/prompts/PromptContentCard'
import { PromptHistoriesModal } from 'lauria/components/prompts/PromptHistoriesModal'
import { PromptModeleTag } from 'lauria/components/prompts/PromptModeleTag'
import { PromptSwitchStatus } from 'lauria/components/prompts/PromptSwitchStatus'
import { RemovePromptModal } from 'lauria/components/prompts/RemovePromptModal'
import { RetrievePromptHistoryModal } from 'lauria/components/prompts/RetrievePromptHistoryModal'
import { usePromptContent } from 'lauria/hooks/usePromptContent'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const Prompt: React.FC<{
  promptId: number
  refetchPrompts: any
  /**
   * Si l'utilisateur a les permissions pour éditer le prompt
   */
  canEditPrompts: boolean
}> = ({ promptId, refetchPrompts, canEditPrompts }) => {
  const {
    changeStatus,
    handleAppClick,
    openRemoveModal,
    setOpenRemoveModal,
    openChangeStatusModal,
    setOpenChangeStatusModal,
    isUpdating,
    isLoading,
    prompt,
    handleDelete,
    isDeleting,
    setOpenHistoryModal,
    openHistoryModal,
    promptHistorises,
    isLoadingPromptHistorises,
    setOpenRetrieveHistoryModal,
    openRetrieveHistoryModal,
    promptHistory,
    handleRetrieveHistory,
    refetchPrompt,
  } = usePromptContent(promptId, refetchPrompts)
  const { t } = useTranslation()
  if (isLoading) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Loader pageCenter />
      </div>
    )
  }

  return (
    <div className="prompt-content-wrapper">
      {prompt && (
        <div className="prompt-detail-layout">
          <div
            className={`prompt-detail-scroll${canEditPrompts ? ' prompt-detail-scroll-with-bar' : ''}`}
          >
            <div className="content-prompt-fields">
              <div className="flex flex-row items-center justify-between gap-x-[10px]">
                <div className="prompt-content-title min-w-0 flex-1 truncate mb-0">
                  {prompt.nomPrompt}
                </div>
                {!openHistoryModal && canEditPrompts && (
                  <button
                    className="btn-without-bg default h-[30px] shrink-0"
                    onClick={() => setOpenHistoryModal(true)}
                  >
                    <FeatherIcone />
                    {t('prompts.historise.see')}
                  </button>
                )}
              </div>
              <div className="flex flex-row items-center">
                <div className="label min-w-[200px] ">
                  {t('prompts.form.modeleDispoLabel')}
                </div>
                <div>
                  {prompt.modele && <PromptModeleTag modele={prompt.modele} />}
                </div>
              </div>
              <div className="flex flex-row items-center justify-between">
                <div className="flex flex-row items-center mt-10px">
                  <div className="label min-w-[200px]">
                    {t('prompts.form.temperatureLabel')}
                  </div>
                  <div>
                    <TemperatureSlider value={prompt.temperature ?? 0.5} />
                  </div>
                </div>
                {canEditPrompts && (
                  <PromptSwitchStatus
                    isActive={prompt.actif ?? false}
                    onClick={() => setOpenChangeStatusModal(true)}
                  />
                )}
              </div>
              {prompt.documents && prompt.documents?.length > 0 && (
                <div className="prompt-documents">
                  <div className="flex flex-row items-center">
                    <NbDocIcon nbDoc={prompt.documents?.length} />
                    <span className="font-semibold ml-[10px]">
                      {t('prompts.documents.documentsAttached')}
                    </span>
                  </div>
                  <div className="mt-[10px]">
                    {prompt.documents.map((doc, index) => (
                      <DocumentCard filename={doc.nomDocument} key={index} />
                    ))}
                  </div>
                </div>
              )}
              <div className="flex flex-row pt-[10px] w-full">
                <div className="w-full">
                  <PromptContentCard prompt={prompt} />
                </div>
              </div>
            </div>
          </div>
          {canEditPrompts && (
            <div className="prompt-detail-action-bar">
              <button
                className="small-btn cancel prompt-detail-action-btn"
                onClick={() => setOpenRemoveModal(true)}
              >
                {t('prompts.delete')}
              </button>
              <button
                className="small-btn default prompt-detail-action-btn"
                onClick={handleAppClick}
              >
                {t('prompts.edit')}
              </button>
            </div>
          )}
          <RemovePromptModal
            open={openRemoveModal}
            setOpen={setOpenRemoveModal}
            handleClick={handleDelete}
            isDeleting={isDeleting}
          />
          <ChangePromptStatusModal
            prompt={prompt}
            open={openChangeStatusModal}
            setOpen={setOpenChangeStatusModal}
            handleClick={changeStatus}
            isLoading={isUpdating}
          />
          <PromptHistoriesModal
            open={openHistoryModal}
            setOpen={setOpenHistoryModal}
            promptHistorises={promptHistorises}
            isLoading={isLoadingPromptHistorises}
            handleRetrieveHistory={handleRetrieveHistory}
          />
          <RetrievePromptHistoryModal
            open={openRetrieveHistoryModal}
            setOpen={setOpenRetrieveHistoryModal}
            promptHistory={promptHistory}
            refetchPrompt={refetchPrompt}
            prompt={prompt}
          />
        </div>
      )}
    </div>
  )
}
